<template>
	<img
		:src="src ? src : fallback"
		:alt="alt"
		:loading="priority ? undefined : 'lazy'"
		:fetchpriority="priority ? 'high' : undefined"
		@error.once="handleError"
	/>
</template>

<script lang="ts" setup>
import fallbackImage from '@/theme/assets/fallback.jpg';

export type Props = {
  src?: string | null
  alt?: string
  fallback?: string
  priority?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  src: undefined,
  alt: 'photo',
  fallback: fallbackImage,
  priority: false,
});

const handleError = (payload: Event) => {
  (payload.target as HTMLImageElement).src = props.fallback;
};
</script>
